import { MODE_INFO, type Mode } from "../content/modes";
import "./ModePicker.css";

interface Props {
  modes: Mode[];
  selected: Mode;
  onSelect: (mode: Mode) => void;
}

export function ModePicker({ modes, selected, onSelect }: Props) {
  return (
    <div
      className="modes"
      role="group"
      aria-label="Choose your maths"
      style={{ gridTemplateColumns: `repeat(${modes.length}, 1fr)` }}
    >
      {modes.map((m) => (
        <button
          key={m}
          type="button"
          className="mode display"
          aria-pressed={m === selected}
          onClick={() => onSelect(m)}
        >
          {MODE_INFO[m].sym}
          <small>{MODE_INFO[m].label}</small>
        </button>
      ))}
    </div>
  );
}
